import React from 'react';
import type ProjectPagesType from '@atlassian/jira-spa-apps-project-pages/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { RedirectToProjectType } from './project-type/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyProjectPages = lazyForPaint<typeof ProjectPagesType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-pages", jiraSpaEntry: "async-project-pages" */ '@atlassian/jira-spa-apps-project-pages'
			),
		),
	{ ssr: false },
);

export const PagesRedirect = (): React.JSX.Element => <RedirectToProjectType page="/pages" />;

const AsyncProjectPages = (): React.JSX.Element => (
	<LazyPage Page={LazyProjectPages} pageId="project-pages" shouldShowSpinner={false} />
);

export default AsyncProjectPages;
